import {React, observer, Fragment} from '@api'
import {CLASSES, useLayoutStore} from '@flexlayout'

export const LayoutMetricsElement = observer(function LayoutMetricsElement() {
  const {styleFont, getClassName, findHeaderBarSizeRef, findTabBarSizeRef, findBorderBarSizeRef} = useLayoutStore()

  const fontStyle = styleFont({visibility: 'hidden'})
  return (
    <Fragment>
      <div key='findHeaderBarSize' ref={findHeaderBarSizeRef} style={fontStyle} className={getClassName(CLASSES.FLEXLAYOUT__TABSET_HEADER_SIZER)}>
        FindHeaderBarSize
      </div>
      <div key='findTabBarSize' ref={findTabBarSizeRef} style={fontStyle} className={getClassName(CLASSES.FLEXLAYOUT__TABSET_SIZER)}>
        FindTabBarSize
      </div>
      <div key='findBorderBarSize' ref={findBorderBarSizeRef} style={fontStyle} className={getClassName(CLASSES.FLEXLAYOUT__BORDER_SIZER)}>
        FindBorderBarSize
      </div>
    </Fragment>
  )
})


// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/view/Layout/LayoutMetrics.tsx